<template>
    <div class="rating-form-section-item-answers">
        <b-form-radio-group class="answer-radio-options"
                            :id="userIn ? `answer-radio-options-group-${userIn.id}-${itemIn.id}` : `answer-radio-options-group-${itemIn.id}`"
                            :key="userIn ? `answer-radio-options-group-${userIn.id}-${itemIn.id}` : `answer-radio-options-group-${itemIn.id}`"
                            v-model="rating_option_id"
                            :options="options"
                            :disabled="isStudent"
                            :aria-describedby="'ariaDescribedby'"
                            :name="userIn ? `rating-form-radio-answers-${userIn.id}-${itemIn.id}` : `rating-form-radio-answers-${itemIn.id}`"
                            @input="selectOption">
        </b-form-radio-group>
    </div>
</template>

<script>
    export default {
        name: 'design-2021-rating-answer-option-component',
        props: ['itemIn', 'projectId', 'sectionIn', 'ratingFormId', 'userIn'],
        data() {
            return {
                isStudent: !!this.$authUser.isStudent(),
                rating_option_id: this.getRatingOptionId(),
                options: this.itemIn.options.map(option => {
                    if(this.sectionIn.type === 1){
                        return {
                            html: `<span class="answer-label">${option.title}</span> <span class="points">(${option.max}pt)</span>`,
                            value: option.id,
                            max: option.max,
                        }
                    } else {
                        return {
                            html: `<span class="answer-label">${option.title}</span>`,
                            value: option.id,
                            max: option.max,
                        }
                    }
                }),
            }
        },

        watch: {
            itemIn: function (value) {
                this.itemIn = value;
                this.rating_option_id = this.getRatingOptionId();
            }
        },

        methods: {
            getRatingOptionId() {
                if(this.userIn !== undefined && this.itemIn.answers.length) {
                    for (const answer of this.itemIn.answers) {
                        if(answer.user_id === this.userIn.id && answer.rating_form_id === this.ratingFormId)
                        {
                            return answer.rating_option_id;
                        }
                    }
                    return '';
                } else {
                    for (const answer of this.itemIn.answers) {
                        if(answer.rating_form_id === this.ratingFormId)
                        {
                            return answer.rating_option_id;
                        }
                    }
                    return ''
                }
            },

            selectOption(option_id) {
                if(!this.isStudent) {
                    this.$emit('updateClosedAnswer', option_id);
                }
            }
        }
    }

</script>

<style scoped lang="scss">
    .rating-form-section-item-answers {
        margin-left: $grid-gutter-width;
    }

    .answer-radio-options ::v-deep{
        display: flex;
        flex-direction: column;
        column-gap: map-get($grid-padding-spacing, ' twenty-on');

        label {
            font-weight: $font-weight-normal;

            &:before,
            &:after {
                top: 0;
            }

            &:hover {
                cursor: pointer;
                font-weight: $font-weight-bold;
            }
        }

        input[type="radio"]:checked {
            & + label {
                color: $primary;
                font-weight: $font-weight-bold;
            }
        }
    }
</style>
